import * as React from 'react';
import Button from 'src/components/common/Button';

import './DeleteCreditCardConfirmation.scss';
import Alert from 'src/components/common/Alert';
import i18n from 'src/translation/i18n';

interface IProps {
  creditCardToken: string;
  onCancel: () => void;
  onDelete: () => void;
  showAlert: boolean;
  onCloseAlert: () => void;
}

const DeleteCreditCardConfirmation: React.FC<IProps> = ({
  showAlert,
  onCloseAlert,
  onDelete,
  onCancel
}) => {
  React.useEffect(() => {
    return () => {
      onCloseAlert();
    };
  }, []);

  return (
    <div className="delete-credit-card-confirmation">
      {showAlert && (
        <Alert
          styleClass="rp-delete-credit-cart-alert"
          handleCloseAlert={onCloseAlert}
          type="error"
          icon="rpds-error"
          message="The card selected is authorized on a pending order(s) and cannot be deleted at this time. Please contact Accounts Receivable for further assistance or attempt deletion once order(s) have invoiced."
        />
      )}
      <span className="rpds-error delete-credit-card-icon" />
      <p className="delete-credit-card-title">
        {i18n.t('common.deleteAction')}{' '}
        {i18n.t('accountCreditCards.tableCreditCard')}{' '}
      </p>
      <p className="delete-credit-card-text">
        {i18n.t('common.areYouSureToDeleteCard')}?
      </p>
      <div className="delete-credit-card-confirm-buttons-container">
        <Button
          label={i18n.t('common.cancel')}
          textTransform="capitalize"
          action={() => onCancel()}
          buttonClass="secondary-button"
        />
        <Button
          label={i18n.t('common.deleteAction')}
          textTransform="capitalize"
          action={() => onDelete()}
          buttonClass="primary-button"
        />
      </div>
    </div>
  );
};

export default DeleteCreditCardConfirmation;
